module.exports = __webpack_public_path__ + "img/collection-weddingRingsHammered.03b7e4e.webp";